// 价税管理
const map = {
  // 价税管理
  listOut: () => import('@/views/taxManagement/ListOut') // 商品价格及库存
}

export default map
